<div [style.min-width.px]='width' [ngClass]="resizeable ? 'resizeable' : ''">
    <span class="ui-column-resizer" (mousedown)='onMouseDown($event)' *ngIf='resizeable'></span>
    <button [ngClass]="columnName + '-column'" >{{columnText}}</button>
</div>